<table [formGroup]="_formGroupSubstitution"
    class="font-size-12 table table-body-lateral-th-400 table-borderless table-sm text-center time-table">
    <thead>
        <tr *ngIf="isReadOnly">
            <th></th>
            <th>Lu</th>
            <th>Ma</th>
            <th>Mi</th>
            <th>Ju</th>
            <th>Vi</th>
        </tr>
        <tr *ngIf="!isReadOnly">
            <th></th>
            <th>Lunes</th>
            <th>Martes</th>
            <th>Miércoles</th>
            <th>Jueves</th>
            <th>Viernes</th>
        </tr>
    </thead>
    <tbody class="checkbox-group">

        <tr *ngIf="!isReadOnly">
            <th scope="row">Todo el día
            </th>
            <td>
                <label class="checkbox-label no-label-text">
                    <input type="checkbox" [checked]="selectionAllMon" (change)="onCheckChangeDay($event,'mon')">
                    <span class="checkmark"></span>
                </label>
            </td>
            <td>
                <label class="checkbox-label no-label-text">
                    <input type="checkbox" [checked]="selectionAllTue" (change)="onCheckChangeDay($event,'tue')">
                    <span class="checkmark"></span>
                </label>
            </td>
            <td>
                <label class="checkbox-label no-label-text">
                    <input type="checkbox" [checked]="selectionAllWed" (change)="onCheckChangeDay($event,'wed')">
                    <span class="checkmark"></span>
                </label>
            </td>
            <td>
                <label class="checkbox-label no-label-text">
                    <input type="checkbox" [checked]="selectionAllThu" (change)="onCheckChangeDay($event,'thu')">
                    <span class="checkmark"></span>
                </label>
            </td>
            <td>
                <label class="checkbox-label no-label-text">
                    <input type="checkbox" [checked]="selectionAllFri" (change)="onCheckChangeDay($event,'fri')">
                    <span class="checkmark"></span>
                </label>
            </td>
        </tr>
        <tr *ngFor="let hour of hourSubstitutionMon.controls; let i = index">
            <th scope="row">
                <label>
                    {{arrayHourSubstitution.mon[i].label}}
                </label>
            </th>
            <td>
                <label formArrayName="hourSubstitutionMon" class="checkbox-label no-label-text text-center">
                    <input type="checkbox" [formControlName]="i" (click)="onClickSlot($event)">
                    <span class="checkmark"></span>
                </label>
            </td>
            <td>
                <label formArrayName="hourSubstitutionTue" class="checkbox-label no-label-text">
                    <input type="checkbox" [formControlName]="i" (click)="onClickSlot($event)">
                    <span class="checkmark"></span>
                </label>
            </td>
            <td>
                <label formArrayName="hourSubstitutionWed" class="checkbox-label no-label-text">
                    <input type="checkbox" [formControlName]="i" (click)="onClickSlot($event)">
                    <span class="checkmark"></span>
                </label>
            </td>
            <td>
                <label formArrayName="hourSubstitutionThu" class="checkbox-label no-label-text">
                    <input type="checkbox" [formControlName]="i" (click)="onClickSlot($event)">
                    <span class="checkmark"></span>
                </label>
            </td>
            <td>
                <label formArrayName="hourSubstitutionFri" class="checkbox-label no-label-text">
                    <input type="checkbox" [formControlName]="i" (click)="onClickSlot($event)">
                    <span class="checkmark"></span>
                </label>
            </td>
        </tr>
    </tbody>
</table>